import { FilterItemButton } from './filter-item-button'
import { SidebarFilterSection } from './sidebar-filter-section'
import styles from './workout-style-filter.module.scss'
import { useFilterContext } from '../../context/filter-context'
import { WorkoutStyle } from '../../dao/core-dao'
import { useWorkoutStyles } from '../../hook/use-workouts'
import React from 'react'

export const WorkoutStyleFilter = (): React.ReactElement | null => {
  const { workoutFilter, toggleFilterEntry } = useFilterContext()
  const { data: allStyles = [] } = useWorkoutStyles()

  if (!allStyles || allStyles.length === 0) {
    return null
  }

  const handleToggleSelectedStyle = (toggleValue: string): void => {
    toggleFilterEntry('styles', toggleValue)
  }

  const renderHouseCategory = (style: WorkoutStyle, additionalClass?: string): React.ReactElement => {
    const isActive = workoutFilter?.styles?.includes(style.id) ?? false
    return (
      <FilterItemButton
        className={`${additionalClass} ${styles.styleButton}`}
        fullWidth={true}
        isActive={isActive}
        onClick={() => handleToggleSelectedStyle(style.id)}
      >
        {style.label.split(' ').map((l) => (
          <span key={l} className="font-roboto-condensed font-semibold text-xs leading-4 text-ivory">
            {l}
          </span>
        ))}
      </FilterItemButton>
    )
  }

  return <SidebarFilterSection title={'Workout Style'} items={allStyles} lineLimit={4} renderItem={renderHouseCategory} />
}
